

// import React, { useEffect, useState } from 'react';
// import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
// import { DollarSign, Users, Activity, UserPlus, TrendingUp } from 'lucide-react';
// import { useFetchData } from '../../../../hooks/useFtechData';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'sonner';
// import ProfileCompletionTracker from './ProfileCompletionTracker';
// import axios from 'axios';
// import { ALL_JOB, ALL_STAT } from '../../../../resources/resource';

// function Homes({ waveCanvasRef }) {
//   const { data: statData } = useFetchData(ALL_STAT);
//   const [position, setPosition] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const token = localStorage.getItem("token");
//   const navigate = useNavigate();
//   const loggedInUser = useSelector((state) => state.user);

//   // Handle CV Creation
//   const handleCv = () => {
//     if (!loggedInUser?.currentUser) {
//       toast.error("Kindly login to continue");
//       navigate("/signin");
//       return;
//     }
//     if (loggedInUser.currentUser.userType !== "jobSeeker") {
//       toast.info("Only available for Job Seekers");
//       return;
//     }
//     navigate(`/${loggedInUser.currentUser._id}/createCV`);
//   };

//   // Fetch Jobseeker Position
//   useEffect(() => {
//     const fetchPosition = async () => {
//       if (!token) return;

//       try {
//         setLoading(true);
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}jobseeker/getjobseekerposition`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setPosition(res.data.position);
//       } catch (error) {
//         console.error("Error fetching position:", error);
//         setPosition(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPosition();
//   }, [token]);

//   // Pie Chart Data
//   const pieData = statData
//     ? [
//         { name: 'Job Seekers', value: statData.jobSeeker?.length || 0, color: '#f97316' },
//         { name: 'Companies', value: statData.companies?.length || 0, color: '#1f2937' },
//         { name: 'Applications', value: statData.applications?.length || 0, color: '#10b981' },
//         { name: 'Jobs', value: statData.jobs?.length || 0, color: '#fb923c' },
//       ]
//     : [];

//   // Bar Chart Data
//   const barData = statData
//     ? [
//         {
//           name: 'Overview',
//           JobSeekers: statData.jobSeeker?.length || 0,
//           Companies: statData.companies?.length || 0,
//           Applications: statData.applications?.length || 0,
//           Jobs: statData.jobs?.length || 0,
//         },
//       ]
//     : [];

//   // Line Chart Data
//   const lineData = statData?.monthlyStats?.length
//     ? statData.monthlyStats.map((stat, index) => ({
//         name: stat.month || `M${index + 1}`,
//         jobSeekers: stat.jobSeekerCount || 0,
//         applications: stat.applicationCount || 0,
//       }))
//     : [
//         { name: 'Jan', jobSeekers: 2400, applications: 4000 },
//         { name: 'Feb', jobSeekers: 1398, applications: 3000 },
//         { name: 'Mar', jobSeekers: 9800, applications: 2000 },
//         { name: 'Apr', jobSeekers: 3908, applications: 2780 },
//       ];

//   // Responsive Water Wave Animation
//   useEffect(() => {
//     const canvas = waveCanvasRef.current;
//     if (!canvas || !statData) return;

//     const ctx = canvas.getContext('2d');
//     let animationFrameId;
//     let phase = 0;

//     const resizeCanvas = () => {
//       const containerWidth = canvas.parentElement?.clientWidth || 300;
//       canvas.width = Math.min(containerWidth - 32, 500); // Safe padding
//       canvas.height = 160;
//     };

//     resizeCanvas();
//     window.addEventListener('resize', resizeCanvas);

//     const totalActivity =
//       (statData.jobSeeker?.length || 0) +
//       (statData.companies?.length || 0) +
//       (statData.applications?.length || 0) +
//       (statData.jobs?.length || 0);

//     const waveHeight = Math.min(totalActivity * 0.4, 80);

//     const drawWave = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // First wave layer
//       ctx.fillStyle = 'rgba(249, 115, 22, 0.25)';
//       ctx.beginPath();
//       ctx.moveTo(0, canvas.height);

//       for (let x = 0; x <= canvas.width; x += 2) {
//         const y = canvas.height * 0.6 + Math.sin((x * 0.015) + phase) * 25;
//         ctx.lineTo(x, y - waveHeight);
//       }

//       ctx.lineTo(canvas.width, canvas.height);
//       ctx.closePath();
//       ctx.fill();

//       // Gradient overlay
//       const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
//       gradient.addColorStop(0, 'rgba(249, 115, 22, 0.6)');
//       gradient.addColorStop(1, 'rgba(249, 115, 22, 0.05)');
//       ctx.fillStyle = gradient;
//       ctx.fillRect(0, 0, canvas.width, canvas.height);

//       phase += 0.04;
//       animationFrameId = requestAnimationFrame(drawWave);
//     };

//     drawWave();

//     return () => {
//       cancelAnimationFrame(animationFrameId);
//       window.removeEventListener('resize', resizeCanvas);
//     };
//   }, [statData, waveCanvasRef]);

//   return (
//     <div className="space-y-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
//       {/* Marquee - Fixed & Responsive */}
//       <div className="bg-gradient-to-r from-purple-700 via-indigo-700 to-purple-700 text-white py-3 overflow-hidden border-b border-white/20 rounded-xl">
//         <div className="flex items-center gap-4 animate-marquee whitespace-nowrap text-sm sm:text-base font-medium">
//           <span className="inline-flex items-center gap-2">
//             <span className="text-yellow-300">★</span>
//             Congratulations! You are the
//             <span className="font-bold text-yellow-300 bg-white/20 px-3 py-1 rounded-lg">
//               #{position || "50"}
//             </span>
//             Jobseeker to join our platform
//             <span className="text-yellow-300">★</span>
//           </span>

//           {/* Duplicate for seamless loop */}
//           <span className="inline-flex items-center gap-2">
//             <span className="text-yellow-300">★</span>
//             Congratulations! You are the
//             <span className="font-bold text-yellow-300 bg-white/20 px-3 py-1 rounded-lg">
//               #{position || "——"}
//             </span>
//             Jobseeker to join our platform
//             <span className="text-yellow-300">★</span>
//           </span>
//         </div>
//       </div>

//       <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 dark:text-gray-100">
//         Welcome to Your Dashboard
//       </h2>

//       <ProfileCompletionTracker />

//       {/* Stats Cards - Fully Responsive */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
//         {[
//           { title: "Total Jobs", value: statData?.jobs?.length || 0, icon: DollarSign, trend: "+12.5%" },
//           { title: "Total Users", value: statData?.jobSeeker?.length || 0, icon: Users, trend: "+8.2%" },
//           { title: "Total Applications", value: statData?.applications?.length || 0, icon: Activity, trend: "+5.3%" },
//           { title: "Total Companies", value: statData?.companies?.length || 0, icon: UserPlus, trend: "+10.7%" },
//         ].map((item, index) => (
//           <div
//             key={index}
//             className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5 sm:p-6 border-l-4 border-orange-500 flex flex-col justify-between h-full"
//           >
//             <div>
//               <p className="text-gray-500 dark:text-gray-400 text-sm">{item.title}</p>
//               <p className="text-3xl font-bold text-gray-800 dark:text-gray-100 mt-2">
//                 {item.value}
//               </p>
//             </div>
//             <div className="flex items-center justify-between mt-4">
//               <p className="text-green-500 text-sm flex items-center">
//                 <TrendingUp className="w-4 h-4 mr-1" />
//                 {item.trend}
//               </p>
//               <item.icon className="w-10 h-10 text-orange-500 opacity-20" />
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Charts Section */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
//         {/* Pie Chart */}
//         <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5 sm:p-6">
//           <h3 className="text-lg sm:text-xl font-semibold mb-4 text-gray-800 dark:text-gray-100">
//             Platform Statistics
//           </h3>
//           <div className="h-64 sm:h-72">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={pieData}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   outerRadius={window.innerWidth < 640 ? 70 : 90}
//                   dataKey="value"
//                 >
//                   {pieData.map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={entry.color} />
//                   ))}
//                 </Pie>
//                 <Tooltip />
//                 <Legend verticalAlign="bottom" height={36} />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Bar Chart */}
//         <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5 sm:p-6">
//           <h3 className="text-lg sm:text-xl font-semibold mb-4 text-gray-800 dark:text-gray-100">
//             Activity Breakdown
//           </h3>
//           <div className="h-64 sm:h-72">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={barData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="JobSeekers" fill="#f97316" />
//                 <Bar dataKey="Companies" fill="#1f2937" />
//                 <Bar dataKey="Applications" fill="#10b981" />
//                 <Bar dataKey="Jobs" fill="#fb923c" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Water Wave Canvas */}
//         <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5 sm:p-6 lg:col-span-2">
//           <h3 className="text-lg sm:text-xl font-semibold mb-4 text-gray-800 dark:text-gray-100">
//             Total Platform Activity
//           </h3>
//           <div className="flex justify-center">
//             <canvas
//               ref={waveCanvasRef}
//               className="w-full max-w-full rounded-xl"
//             />
//           </div>
//           <p className="text-center text-sm text-gray-600 dark:text-gray-400 mt-4">
//             Total Activity: {(statData?.jobSeeker?.length || 0) +
//               (statData?.companies?.length || 0) +
//               (statData?.applications?.length || 0) +
//               (statData?.jobs?.length || 0)}
//           </p>
//         </div>

//         {/* Line Chart */}
//         <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5 sm:p-6 lg:col-span-2">
//           <h3 className="text-lg sm:text-xl font-semibold mb-4 text-gray-800 dark:text-gray-100">
//             Job Seekers & Applications Trend
//           </h3>
//           <div className="h-72 sm:h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={lineData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line type="monotone" dataKey="jobSeekers" stroke="#f97316" strokeWidth={3} />
//                 <Line type="monotone" dataKey="applications" stroke="#1f2937" strokeWidth={3} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Homes;







import React, { useEffect, useState } from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { DollarSign, Users, Activity, UserPlus, TrendingUp } from 'lucide-react';
import { useFetchData } from '../../../../hooks/useFtechData';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import ProfileCompletionTracker from './ProfileCompletionTracker';
import axios from 'axios';
import { ALL_JOB, ALL_STAT } from '../../../../resources/resource';

function Homes({ waveCanvasRef }) {
  const { data: statData } = useFetchData(ALL_STAT);
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.user);

  // Handle CV Creation
  const handleCv = () => {
    if (!loggedInUser?.currentUser) {
      toast.error("Kindly login to continue");
      navigate("/signin");
      return;
    }
    if (loggedInUser.currentUser.userType !== "jobSeeker") {
      toast.info("Only available for Job Seekers");
      return;
    }
    navigate(`/${loggedInUser.currentUser._id}/createCV`);
  };

  // Fetch Jobseeker Position
  useEffect(() => {
    const fetchPosition = async () => {
      if (!token) return;
      try {
        setLoading(true);
        const res = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/getjobseekerposition`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPosition(res.data.position);
      } catch (error) {
        console.error("Error fetching position:", error);
        setPosition(null);
      } finally {
        setLoading(false);
      }
    };
    fetchPosition();
  }, [token]);

  // Pie Chart Data
  const pieData = statData ? [
    { name: 'Job Seekers', value: statData.jobSeeker?.length || 0, color: '#f97316' },
    { name: 'Companies', value: statData.companies?.length || 0, color: '#1f2937' },
    { name: 'Applications', value: statData.applications?.length || 0, color: '#10b981' },
    { name: 'Jobs', value: statData.jobs?.length || 0, color: '#fb923c' },
  ] : [];

  // Bar Chart Data
  const barData = statData ? [{
    name: 'Overview',
    JobSeekers: statData.jobSeeker?.length || 0,
    Companies: statData.companies?.length || 0,
    Applications: statData.applications?.length || 0,
    Jobs: statData.jobs?.length || 0,
  }] : [];

  // Line Chart Data
  const lineData = statData?.monthlyStats?.length 
    ? statData.monthlyStats.map((stat, index) => ({
        name: stat.month || `M${index + 1}`,
        jobSeekers: stat.jobSeekerCount || 0,
        applications: stat.applicationCount || 0,
      }))
    : [
        { name: 'Jan', jobSeekers: 2400, applications: 4000 },
        { name: 'Feb', jobSeekers: 1398, applications: 3000 },
        { name: 'Mar', jobSeekers: 9800, applications: 2000 },
        { name: 'Apr', jobSeekers: 3908, applications: 2780 },
      ];

  // Water Wave Animation
  useEffect(() => {
    const canvas = waveCanvasRef.current;
    if (!canvas || !statData) return;

    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let phase = 0;

    const resizeCanvas = () => {
      const containerWidth = canvas.parentElement?.clientWidth || 300;
      canvas.width = Math.min(containerWidth - 32, 500);
      canvas.height = 160;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const totalActivity = (statData.jobSeeker?.length || 0) + 
                         (statData.companies?.length || 0) + 
                         (statData.applications?.length || 0) + 
                         (statData.jobs?.length || 0);

    const waveHeight = Math.min(totalActivity * 0.4, 80);

    const drawWave = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // First wave layer
      ctx.fillStyle = 'rgba(249, 115, 22, 0.25)';
      ctx.beginPath();
      ctx.moveTo(0, canvas.height);
      for (let x = 0; x <= canvas.width; x += 2) {
        const y = canvas.height * 0.6 + Math.sin((x * 0.015) + phase) * 25;
        ctx.lineTo(x, y - waveHeight);
      }
      ctx.lineTo(canvas.width, canvas.height);
      ctx.closePath();
      ctx.fill();

      // Gradient overlay
      const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      gradient.addColorStop(0, 'rgba(249, 115, 22, 0.6)');
      gradient.addColorStop(1, 'rgba(249, 115, 22, 0.05)');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      phase += 0.04;
      animationFrameId = requestAnimationFrame(drawWave);
    };

    drawWave();

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, [statData, waveCanvasRef]);

  // Stats Data
  const stats = [
    { title: "Total Jobs", value: statData?.jobs?.length || 0, icon: DollarSign, trend: "+12.5%" },
    { title: "Total Users", value: statData?.jobSeeker?.length || 0, icon: Users, trend: "+8.2%" },
    { title: "Total Applications", value: statData?.applications?.length || 0, icon: Activity, trend: "+5.3%" },
    { title: "Total Companies", value: statData?.companies?.length || 0, icon: UserPlus, trend: "+10.7%" },
  ];

  return (
    <div className="space-y-6 pb-8 px-4 md:px-6">
      {/* Marquee */}
      <div className="bg-gradient-to-r from-orange-500 to-amber-600 text-white py-3 px-4 rounded-2xl overflow-hidden">
        <div className="flex items-center gap-3 animate-marquee whitespace-nowrap text-sm font-medium">
          ★ Congratulations! You are the #{position || "50"} Jobseeker to join our platform ★
          <span className="mx-8">★ Congratulations! You are the #{position || "——"} Jobseeker to join our platform ★</span>
        </div>
      </div>

      <h1 className="text-3xl font-bold text-gray-900">Welcome to Your Dashboard</h1>

      {/* Stats Cards - Fully Responsive */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((item, index) => (
          <div key={index} className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 hover:shadow-md transition-all">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-500 text-sm">{item.title}</p>
                <p className="text-3xl font-bold mt-1">{item.value}</p>
              </div>
              <div className="w-12 h-12 bg-orange-100 rounded-2xl flex items-center justify-center">
                <item.icon className="w-6 h-6 text-orange-600" />
              </div>
            </div>
            <div className="text-emerald-600 text-sm font-medium mt-3 flex items-center gap-1">
              <TrendingUp size={16} /> {item.trend}
            </div>
          </div>
        ))}
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Pie Chart */}
        <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100">
          <h3 className="font-semibold text-lg mb-5">Platform Statistics</h3>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={pieData} cx="50%" cy="50%" innerRadius={70} outerRadius={110} dataKey="value">
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Bar Chart */}
        <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100">
          <h3 className="font-semibold text-lg mb-5">Activity Breakdown</h3>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={barData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="JobSeekers" fill="#f97316" />
                <Bar dataKey="Companies" fill="#1f2937" />
                <Bar dataKey="Applications" fill="#10b981" />
                <Bar dataKey="Jobs" fill="#fb923c" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Water Wave Canvas */}
      <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100">
        <h3 className="font-semibold text-lg mb-4">Total Platform Activity</h3>
        <div className="relative">
          <canvas ref={waveCanvasRef} className="w-full rounded-2xl" />
          <div className="absolute bottom-6 left-6 text-white">
            <p className="text-4xl font-bold">
              {(statData?.jobSeeker?.length || 0) + 
               (statData?.companies?.length || 0) + 
               (statData?.applications?.length || 0) + 
               (statData?.jobs?.length || 0)}
            </p>
            <p className="text-sm opacity-80">Total Activity</p>
          </div>
        </div>
      </div>

      {/* Line Chart */}
      <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100">
        <h3 className="font-semibold text-lg mb-5">Job Seekers & Applications Trend</h3>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={lineData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="jobSeekers" stroke="#f97316" strokeWidth={3} />
              <Line type="monotone" dataKey="applications" stroke="#10b981" strokeWidth={3} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Profile Completion */}
      <ProfileCompletionTracker />
    </div>
  );
}

export default Homes;